<template>
    <div class='setting-box'>
        <v-row class="px-2 ma-0">
            <v-col
                md="12"
                lg="6"
                xl="6" 
                sm="12"
                v-for="(item, index) in listData"
                :key="index">
                <div class="list" :style="{'height': $vuetify.breakpoint.mdAndDown ? 'auto' : '116px'}">
                    <div class="img-box">
                        <img :src="'data:image/png;base64,'+item.logoBase64" alt="">
                    </div>
                    <div class="box">
                        <div style="font-size:14px;color:#333;">{{item.name}}</div>
                        <div style="font-size:14px;color:#999">{{item.descp}}</div>
                    </div>
                </div>
            </v-col>
        </v-row>
        <!-- <div class="list">
            
        </div> -->
        <div class="text-center pt-3">
            <v-btn small outlined @click="close" height="40">
                {{$t('btn.close')}}
            </v-btn>
        </div>
    </div>
</template>

<script>
import { getMfa, updateMfa } from "@/api/index";

export default {
    data() {
        return {
            listData: []
        };
    },
    created() {
        this.getData()
    },
    methods: {
        getData() {
            getMfa().then(res=> {
                if (res.code == this.$GLOBA.StatusOK) {
                    this.listData = res.data
                }
            })
            // this.listData = [
            //     { pic: require('@/assets/img/setting-01.png'), title: '短信验证码', text: '通过短信验证码认证登录', switch: true },
            //     { pic: require('@/assets/img/setting-02.png'), title: '电子邮箱验证', text: '通过电子邮件验证码认证登录', switch: true },
            //     { pic: require('@/assets/img/setting-03.png'), title: 'OTP动态口令认证', text: '通过OTP动态口令认证安全登录', switch: true },
            //     { pic: require('@/assets/img/setting-04.png'), title: 'UAF指纹/人脸验证', text: '通过给飞天云信令的指纹或人脸...', switch: true },
            //     { pic: require('@/assets/img/setting-05.png'), title: 'FIDO U2F指纹认证', text: '通过FIDO硬件设备，以识别用户...', switch: true },
            //     // { pic: require('@/assets/img/setting-06.png'), title: '滑动拼图验证', text: '通过滑动拼图进行认证', switch: true },
            //     // { pic: require('@/assets/img/setting-07.png'), title: '文字/图标点选验证', text: '通过文字/图标点选进行认证', switch: true },
            //     // { pic: require('@/assets/img/setting-08.png'), title: '算术表达式图片验证', text: '通过图形数学公式计算进行认证', switch: true },
            // ]
        },
        // switchFun(key, item) {
        //     let params = {
        //         [item.key]: key 
        //     }
        //     updateMfa(params).then(res=> {
        //         if (res.code == this.$GLOBA.StatusOK) {
        //             this.$message.success(res.message)
        //         } else {
        //             this.getData()
        //         }
        //     })
        // },
        close() {
            this.$emit("close")
        },
    },
}
</script>

<style lang='scss' scoped>
.setting-box {
    // display: flex;
    // flex-wrap: wrap;
    // padding: 0 30px;
    .list {
        // width: 45%;
        // height: 116px;
        display: flex;
        align-items: center;
        // margin-bottom: 30px;
        border: 1px solid #ddd;
        border-radius: 10px;
        padding: 15px 20px;
        .img-box {
            width: 55px;
            height: 55px;
        }
        .box {
            // width: 250px;
            padding-left: 20px;
            text-align: left;
        }
    }
}
::v-deep .list:nth-child(2n-1){
    // margin-right: 10%;
}
::v-deep .model-btn{
    width: 100%;
}
::-webkit-scrollbar{
    display:none
}
</style>